import {combineReducers} from 'redux'
import {all, fork} from 'redux-saga/effects'
import {
  IState as IInstitutionState,
  reducer as institutionReducer,
} from './institution'
import {
  IDependencies as IRequestDependencies,
  IState as IIsFetchingState,
  reducer as isFetchingReducer,
  saga as requestSaga,
} from './request'

export interface IState {
  institution: IInstitutionState
  isFetching: IIsFetchingState
}

export const reducer = combineReducers<IState>({
  institution: institutionReducer,
  isFetching: isFetchingReducer,
})

export type Dependencies = IRequestDependencies
export function* saga(dependencies: Dependencies): any {
  yield all([
    fork<IRequestDependencies>(requestSaga, dependencies),
  ])
}

export {getStudyCoordinatorRequest} from './request'
export * from './selectors'



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/study-coordinator/index.ts